import { useNotification } from '@nfinite/react-hubstairs/components/Notification'
import { hasErrorCode, ERROR_CODE } from 'requests/errors'
import useTranslate from 'hooks/useTranslate'

import translations from './translations'

export function useNotify() {
  const { pushSuccess, pushError, pushWarning } = useNotification()
  const translate = useTranslate()

  function notifySuccess(messageIntl, optionsOverride = {}) {
    const message = translate(messageIntl)
    pushSuccess(message, optionsOverride)
  }

  function notifyDefaultError(error = {}, options) {
    let errorMessage = translate(translations.defaultError)
    if (hasErrorCode(error, ERROR_CODE.ACTION_PERMISSION_ERROR) || hasErrorCode(error, ERROR_CODE.PERMISSION_ERROR)) {
      errorMessage = translate(translations.permissionDenied)
    }

    pushError(errorMessage, options)
  }

  function notifyCustomError({ values, ...messageIntl }, options) {
    const message = translate(messageIntl, values)
    pushError(message, options)
  }

  function notifyError({ message, error } = {}, optionsOverride = {}) {
    if (message) {
      return notifyCustomError(message, optionsOverride)
    } else {
      return notifyDefaultError(error, optionsOverride)
    }
  }

  function notifyWarning(messageIntl, optionsOverride = {}) {
    const message = translate(messageIntl)
    pushWarning(message, optionsOverride)
  }

  return { notifySuccess, notifyError, notifyCustomError, notifyWarning }
}
